import React from 'react';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, franchiseeId, ...rest }) => {
	const columns = [
		{
			header: t('User_FirstName'),
			accessor: 'firstName',
			sortable: true
		},
		{
			header: t('User_LastName'),
			accessor: 'lastName',
			sortable: true
		},
		{
			header: t('User_Username'),
			accessor: 'username',
			sortable: true
		},
		{
			header: t('User_Email'),
			accessor: 'email',
			sortable: true
		},
		{
			header: t('Teacher_Enabled'),
			accessor: 'enabled',
			sortable: true,
			cell: (enabled) => (ui.formatBoolean(enabled))
		},
		{
			header: t('Teacher_UserEnabled'),
			accessor: 'userEnabled',
			sortable: true,
			cell: (userEnabled) => (ui.formatBoolean(userEnabled))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => <Link to={`/franchisees/${franchiseeId}/teachers/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>
		}
	];

	return (
		<div>
			<PagedEntitiesList columns={columns} listActions={<NewButton newItemPath={`/franchisees/${franchiseeId}/teachers/new`} />} {...rest} />
		</div>
	);
};

export default withTranslation()(List);